// src/pages/FollowersPage.jsx

import React, { useEffect, useState } from "react";
import api from "../api";
import { useParams } from "react-router-dom";
import "../theme/design.css";

export default function FollowersPage() {
  const { handle } = useParams();

  const [tab, setTab] = useState("followers");
  const [list, setList] = useState([]);

  useEffect(() => {
    load();
  }, [tab, handle]);

  const load = async () => {
    try {
      const { data } = await api.get(`/profiles/${handle}/${tab}`);
      setList(data.users || []);
    } catch (e) {
      console.error(e);
    }
  };

const removeFollower = async (userId) => {
  try {
    await api.delete(`/profiles/${userId}/remove-follower`);
    setList(prev => prev.filter(u => u.user_id !== userId));
  } catch (e) {
    console.error(e);
    alert("Failed to remove follower");
  }
};

const unfollow = async (userId) => {
  try {
    await api.delete(`/profiles/${userId}/unfollow`);
    setList(prev => prev.filter(u => u.user_id !== userId));
  } catch (e) {
    console.error(e);
    alert("Failed to unfollow");
  }
};

  return (
    <div className="page">

      <div className="tabs">
        <button
          className={`pill ${tab === "followers" ? "active" : ""}`}
          onClick={() => setTab("followers")}
        >
          Followers
        </button>

        <button
          className={`pill ${tab === "following" ? "active" : ""}`}
          onClick={() => setTab("following")}
        >
          Following
        </button>
      </div>

      <div className="feed-col">

  {list.length === 0 && (
    <div style={{ padding: 12, color: "#9ca3af" }}>
      No users found.
    </div>
  )}

  {list.map((u) => (
          <div key={u.user_id} className="post-card">

            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <img
                src={u.profile_pic_url || "/uploads/default-avatar.png"}
                alt=""
                style={{ width: 40, height: 40, borderRadius: "50%" }}
              />

              <div style={{ flex: 1 }}>
                <div>{u.username}</div>
                <div style={{ color: "#9ca3af" }}>@{u.user_id}</div>
                
              </div>

              <button
  className="btn"
  onClick={() =>
    tab === "followers"
      ? removeFollower(u.user_id)
      : unfollow(u.user_id)
  }
>
  {tab === "followers" ? "Remove" : "Unfollow"}
</button>

            </div>

          </div>
        ))}
      </div>

    </div>
  );
}